export const TEAM_FILTER_KEY_SEARCH = 'q';
export const TEAM_FILTER_KEY_DEPARTMENT = 'department';
export const TEAM_FILTER_KEY_SENIORITY = 'seniority';
export const TEAM_FILTER_KEY_ROLE = 'role';
export const TEAM_FILTER_KEY_STATUS = 'status';
export const TEAM_FILTER_KEY_MANAGER = 'manager';
export const TEAM_FILTER_KEY_CAPACITY = 'capacity';
export const TEAM_FILTER_KEY_IS_MANAGER = 'isManager';
export const TEAM_FILTER_KEY_MEMBERSHIP_TYPE = 'membershipType';
export const TEAM_FILTER_KEY_COUNTRY = 'country';
export const TEAM_FILTER_KEY_CITY = 'city';

export const TEAM_TABLE_FILTER_KEYS = [
  TEAM_FILTER_KEY_SEARCH,
  TEAM_FILTER_KEY_DEPARTMENT,
  TEAM_FILTER_KEY_SENIORITY,
  TEAM_FILTER_KEY_ROLE,
  TEAM_FILTER_KEY_STATUS,
  TEAM_FILTER_KEY_MANAGER,
  TEAM_FILTER_KEY_CAPACITY,
  TEAM_FILTER_KEY_IS_MANAGER,
  TEAM_FILTER_KEY_MEMBERSHIP_TYPE,
  TEAM_FILTER_KEY_COUNTRY,
  TEAM_FILTER_KEY_CITY,
];

export const TEAM_TABLE_FILTERS_STORAGE_KEY = 'team-table-filters';
